import { fetchApi } from './api';

export interface HomeSummaryResponse {
  pending_orders_to_receive: number;
}

export const dashboardService = {
  getHomeSummary: async (warehouseId: number): Promise<HomeSummaryResponse> => {
    return fetchApi<HomeSummaryResponse>('dashboard/home-summary/', {
      params: { warehouse_id: warehouseId },
    });
  },
};
